import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DsSharedLazyModule } from '@direction/translate';
import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { EssentialModule } from './01-essential/essential.module';
import { FinancialModule } from './02-financial/financial.module';
import { InvoicingModule } from './03-invoicing/invoicing.module';
import { TissModule } from './04-tiss/tiss.module';
import { AdminModule } from './05-admin/admin.module';
import { MainComponent } from './main.component';
import { MainRoutingModule } from './main.routing';

@NgModule({
  declarations: [MainComponent],
  imports: [
    CommonModule,
    MainRoutingModule,
    DsSharedLazyModule,
    CoreModule,
    EssentialModule,
    TissModule,
    FinancialModule,
    InvoicingModule,
    SharedModule,
    AdminModule
  ]
})
export class MainModule {}
